import curry from "../../lib/core/functional/curry";
import createSmartIntersector from "../../utils/createSmartIntersector";
import createQueue from "../../utils/simpleQueue";
import makeTransportContext from "../../utils/makeTransportContext";
import { dispatchNextPage } from "../../transport/nextPage";

import { hasMoreContent, renderLoaded, calculateLoadingHeight } from "./_common";

const LOADING_CLASS = "rm-loading";
const queue = createQueue(3);

function resetAnchor(anchor, page, node, rawHtmlResp) {
    if (!anchor.classList.contains("wrapper-lazy-loading") && hasMoreContent(node, rawHtmlResp)) {
        const newAnchor = anchor.cloneNode();
        newAnchor.classList.remove;
        newAnchor.id = `next-page-${page}`;
        newAnchor.style.height = "1px";
        newAnchor.classList.remove(LOADING_CLASS);
        anchor.parentElement.insertBefore(newAnchor, anchor.nextSibling);
    }
    anchor.parentElement.removeChild(anchor);
}

const onInfiniteNextPageLoaded = curry(function onInfiniteNextPageLoaded(
    target,
    resourceId,
    [data, page]
) {
    queue.release(resourceId);
    const node = renderLoaded(target, data);
    return resetAnchor(target, page, node, data.posts_html);
});

function adjustAnchorWhileLoading(target) {
    target.style.height = `${calculateLoadingHeight(target.parentElement)}px`;
    target.classList.add(LOADING_CLASS);
}

const onInfiniteLoadIntersect = curry(function onInfiniteLoadIntersect(context, entry) {
    const { target } = entry;

    if (
        !target.dataset.sklId ||
        ("hasMore" in target.dataset && target.dataset.hasMore !== "true") ||
        ("morePostsExists" in target.dataset && target.dataset.morePostsExists !== "true")
    ) {
        return;
    }

    adjustAnchorWhileLoading(target);

    function onFreeSlot(resourceId) {
        dispatchNextPage(makeTransportContext(target, context)).then(
            onInfiniteNextPageLoaded(target, resourceId)
        );
    }

    queue.request(3000).then(onFreeSlot);
});

function activateInfiniteScrollWrappers(selector) {
    Array.from(document.querySelectorAll(selector)).forEach((el) => {
        if (el.dataset.hasMore === true) {
            el.classList.remove("hidden");
        }
    });
}

export default function setUpInfiniteScrollLoadPage(context) {
    const selector = ".infinite-scroll-wrapper";
    activateInfiniteScrollWrappers(selector);

    createSmartIntersector(context.intersectionObserverProvider, {
        selector,
        onIntersect: onInfiniteLoadIntersect(context),
        thresholdCalculator: {
            "4g": function on4G() {
                return Math.max(window.innerHeight * 3, 700);
            },
            "3g": function on3G() {
                return Math.max(window.innerHeight * 3.5, 900);
            },
        },
    });
    return context;
}
